import React from 'react'
import cn from 'classnames'

const Modal = props => {
  const className = cn('modal', {show: props.showing})

  return <div className={className}>
    <div className='modal-window' style={props.style}>
      <div className='modal-content'>
        {props.children}
      </div>
    </div>
  </div>
}

Modal.defaultProps = {
  showing: false
}

export default Modal



// WEBPACK FOOTER //
// ./app/components/ui/Modal.js